var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"locale-changer",class:{ dark: _vm.dark, light: !_vm.dark },on:{"click":_vm.clickOpenModal}},[_c('div',{staticClass:"explanation"},[_vm._v(" "+_vm._s(_vm.$t('label'))+" ")]),_c('div',{staticClass:"language"},[_vm._v(" "+_vm._s(_vm.languages.localeMap[_vm.$i18n.locale])+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }